import { render, staticRenderFns } from "./RewardsCardList.vue?vue&type=template&id=076c60b2&scoped=true&"
import script from "./RewardsCardList.vue?vue&type=script&lang=js&"
export * from "./RewardsCardList.vue?vue&type=script&lang=js&"
import style0 from "./RewardsCardList.vue?vue&type=style&index=0&id=076c60b2&lang=scss&scoped=true&"
import style1 from "./RewardsCardList.vue?vue&type=style&index=1&id=076c60b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c60b2",
  null
  
)

export default component.exports